import React, { useState, useMemo, useContext, createContext,useEffect} from 'react';
import { CssBaseline, AppBar, Toolbar, Typography, Box, Paper, Grid, Avatar, ListItemIcon, Button, Stack, Chip, LinearProgress, Card, Divider, IconButton, Tooltip, List, ListItem, ListItemText } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import { SocketProvider } from './contexts/SocketContext';
import CallIcon from '@mui/icons-material/Call';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PieChartIcon from '@mui/icons-material/PieChart';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import PersonIcon from '@mui/icons-material/Person';
import DevicesIcon from '@mui/icons-material/Devices';
import LogoutIcon from '@mui/icons-material/Logout';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import HomeIcon from '@mui/icons-material/Home';
import ChatIcon from '@mui/icons-material/Chat';
import BusinessIcon from '@mui/icons-material/Business';
import ForumIcon from '@mui/icons-material/Forum';
import ContactsIcon from '@mui/icons-material/Contacts';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import PaymentIcon from '@mui/icons-material/Payment';
import MapIcon from '@mui/icons-material/Place';
import PhoneCallbackIcon  from '@mui/icons-material/PhoneCallback';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import AppHeader from './components/AppHeader';
import Sidebar from './components/Sidebar';
import UserMasterPage from './pages/UserMasterPage';
import RolesAndServicesPage from './pages/RolesAndServicesPage';
import CallLogsPage from './pages/CallLogsPage';
import ChatPage from './pages/ChatPage';
import TicketPage from './pages/TicketPage';
import LoginPage from './pages/LoginPage';
import ActiveChatPage from './pages/ActiveChatPage';
import DeviceManagementPage from './pages/DeviceManagementPage';
import CompanyDetailsPage from './pages/CompanyDetailsPage';
import Interactions from './pages/InteractionsPage';
import InteractionsNew from './pages/InteractionsPageNew';
import AddressBookPage from './pages/AddressBookPage';
import DashboardPage from './pages/DashboardPage';
import PagePermissionPage from './pages/PagePermissionPage';
import DoctorChatViewPage from './pages/DoctorChatViewPage';
import DoctorLoginPage from './pages/DoctorLoginPage';
import ProMasterPage from './pages/ProMasterPage';
import PaymentReportPage from './pages/PaymentReportPage';
import PatientPaymentReportPage from './pages/PatientPaymentReportPage';
import MapPage from './pages/MapPage';
import PatPayReportGraphs from './pages/PatPayReportGraphs';
import {ToastProvider} from './customcomponents/CustomToast';
import CallLogsPageCopy from './pages/CallLogsPageCopy';
import TATReportPage from './pages/TATReportPage';
import PagePermissions from './pages/PagePermissions';
import { getAllPageSettings } from './api';
// Remove jwt-decode import

const menuItems = [
  {
    text: 'Dashboard',
    path: '/',
    icon: <HomeIcon />,
  },
  {
    text: 'User',
    path: '/user',
    icon: <PersonIcon />,
  },
  {
    text: 'Roles & Services',
    path: '/roles-services',
    icon: <AssignmentIcon />,
  },
  {
    text: 'Call Logs',
    path: '/call-logs',
    icon: <CallIcon />,
  },
  {
    text: 'Address Book',
    path: '/address-book',
    icon: <ContactsIcon />,
  },
  // {
  //   text: 'Detailed Call Logs',
  //   path: '/detailed-calls',
  //   icon: <PhoneCallbackIcon  />,
  // },
  {
    text: 'Interactions',
    path: '/interactions-new',
    icon: <ForumIcon />,
  },
  {
    text: 'Device Management',
    path: '/device-management',
    icon: <DevicesIcon />,
  },
  // {
  //   text: 'Company Details',
  //   path: '/company-details',
  //   icon: <BusinessIcon />,
  // },
  // {
  //   text: 'Page Permission',
  //   path: '/page-permission',
  //   icon: <AssignmentIcon />,
  // },
  {
    text: 'PRO Master',
    path: '/pro-master',
    icon: <BusinessIcon />,
  },
  // {
  //   text: 'Payment Report',
  //   path: '/payment-report',
  //   icon: <PaymentIcon />,
  // },
  {
    text: 'Patient Payment Report',
    path: '/ppayment-report',
    icon: <PieChartIcon />,
  },
  // {
  //   text: 'TAT Report',
  //   path: '/tat-report',
  //   icon: <HourglassBottomIcon />,
  // },
  {
    text: 'Patient Map View',
    path: '/maps',
    icon: <MapIcon />,
  },
  // {
  //   text: 'Doctor Chat View',
  //   path: '/doctor-chat-view',
  //   icon: <SmartphoneIcon />,
  // },
];

const notifications = [
  { id: 1, text: '3 requests need review', icon: <NotificationsActiveIcon color="warning" /> },
  { id: 2, text: '2 users pending approval', icon: <PersonIcon color="info" /> },
  { id: 3, text: 'WhatsApp integration updated', icon: <CheckCircleIcon color="success" /> },
];
const tipOfTheDay = "Did you know? You can quickly add a new user or service from the Quick Actions panel!";

export const SettingsContext = createContext();
function App() {
  // Persistent login: check for token in localStorage
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!localStorage.getItem('token'));
  const userRole = localStorage.getItem('userRole');
  console.log('User Role from localStorage:',typeof userRole, userRole?.toLowerCase());
  const [settings,setSettings]=useState([]);

   useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await getAllPageSettings();
        setSettings(data.data);
        // console.log("Fetched Page Settings:", data.data);
      } catch (error) {
        console.error("Failed to load page settings", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);  
    localStorage.clear(); // Clear all localStorage on logout
    window.location.href = '/';   
  };

function AppLayoutWithLogout() {
  const location = useLocation();
  const [mode, setMode] = useState('light');
  const [sidebarExpanded, setSidebarExpanded] = useState(false);

  const theme = useMemo(() =>
    createTheme({
      palette: {
        mode,
        primary: {
          main: '#0088cc',
          contrastText: '#fff',
        },
        secondary: {
          main: '#29b6f6',
        },
        background: {
          default: mode === 'light' ? '#f4f6f8' : '#181a1b',
          paper: mode === 'light' ? '#fff' : '#23272f',
          text:mode === 'light' ? 'black':'white',
          textsecondary:mode === 'light' ? 'rgba(0, 0, 0, 0.5)':'white',
          gradienttext: mode === "light" ? "black" : "rgba(240, 240, 240, 0.92)",
        },
        text: {
          primary: mode === 'light' ? '#222' : '#000',
          secondary: '#555',
        },
      },
    }), [mode]
  );

  const drawerWidth = sidebarExpanded ? 240 : 60;
  const appBarHeight = 64; // default MUI AppBar height


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      
      {/* App Header (Fixed) */}
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <AppHeader
          onMenuClick={() => setSidebarExpanded((prev) => !prev)}
          mode={mode}
          setMode={setMode}
          handleLogout={handleLogout}
          userName="Admin John"
        />
      </AppBar>

      {/* Sidebar (Fixed) */}
      <Box
        component="nav"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          position: 'fixed',
          top: appBarHeight,
          height: `calc(100% - ${appBarHeight}px)`,
          zIndex: (theme) => theme.zIndex.drawer,
        }}
      >
        {
          userRole?.toLowerCase() === 'admin' || userRole?.toLowerCase() === 'superadmin' ? (
            <Sidebar
              expanded={sidebarExpanded}
              onToggle={() => setSidebarExpanded((prev) => !prev)}
              menuItems={menuItems}
              drawerWidth={drawerWidth}
              collapsedWidth={60}
              location={location}
            />
          ) : null
        }
      </Box>

      {/* Main Content Area (scrollable) */}
      <Box
        component="main"
        sx={{
          marginLeft: `${drawerWidth}px`,
          marginTop: { xs: 7, sm: `${appBarHeight}px` },
          p: {xs:0.2,sm:3},
          background: theme.palette.background.default,
          // minHeight: '100vh',
          height: `calc(100dvh - ${appBarHeight}px)`,
          overflowY: 'auto',
        }}
      >
        {
          userRole?.toLowerCase() === 'admin' || userRole?.toLowerCase() === 'superadmin' ? (
            <Routes>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/user" element={<UserMasterPage />} />
              <Route path="/roles-services" element={<RolesAndServicesPage />} />
              {/* <Route path="/call-logs" element={<CallLogsPage />} /> */}
              <Route path="/call-logs" element={<CallLogsPageCopy />} />
              <Route path="/interactions" element={<Interactions />} />
              <Route path="/interactions-new" element={<InteractionsNew />} />
              <Route path="/address-book" element={<AddressBookPage />} />
              <Route path="/device-management" element={<DeviceManagementPage />} />
              <Route path="/company-details" element={<CompanyDetailsPage />} />
              {/* <Route path="/page-permission" element={<PagePermissionPage />} /> */}
              <Route path="/page" element={<PagePermissions />} />
              <Route path="/pro-master" element={<ProMasterPage />} />
              <Route path="/payment-report" element={<PaymentReportPage />} />
              <Route path="/chat/:id" element={<ChatPage />} />
              <Route path="/ticket/:phone" element={<TicketPage />} />
              {/* <Route path="/doctor-chat-view" element={<DoctorChatViewPage />} /> */}
              <Route path="/ppayment-report" element={<PatientPaymentReportPage />} />
              <Route path="/tat-report" element={<TATReportPage />} />
              <Route path="/maps" element={<MapPage />} />
              <Route path="/stats" element={<PatPayReportGraphs />} />
              <Route path="*" element={<DashboardPage />} />
              <Route path="/detailed-calls" element={<CallLogsPageCopy />} />
            </Routes>
          ) : (
            <Routes>
              <Route path="/" element={<DoctorChatViewPage/>} />
              <Route path="*" element={<DoctorChatViewPage />} />
            </Routes>
          )
        }
      </Box>
    </ThemeProvider>
  );
}

  return (
    <SettingsContext.Provider value={{settings,userRole}}>
      <ToastProvider>
        <SocketProvider isAuthenticated={isAuthenticated}>
          <Router>
            {isAuthenticated ? (
              <AppLayoutWithLogout />
            ) : (
              <Routes>
                <Route path="/doctor-login" element={<DoctorLoginPage onLogin={handleLogin} />} />
                <Route path="*" element={<LoginPage onLogin={handleLogin} />} />
              </Routes>
            )}
          </Router>
        </SocketProvider>
      </ToastProvider>
    </SettingsContext.Provider>
  );
}

export default App;